import React from "react";
import LogoWhite from "../../assets/images/logo_exaloan_long_white_l.png";

// Split-screen frame shared by every Login.js step: brand panel on the left
// (hidden on small screens), the step's own form card on the right.
const AuthLayout = ({ children }) => (
  <div className="auth-screen">
    <section className="auth-hero" aria-hidden="true">
      <div className="auth-hero-grid" />
      <div className="auth-hero-glow" />
      <img alt="" className="auth-hero-logo" src={LogoWhite} />
      <div className="auth-hero-copy">
        <span className="auth-hero-eyebrow">ExaPort</span>
        <h2 className="auth-hero-title">Loan data in.<br />Clear insight out.</h2>
        <p className="auth-hero-text">
          Upload loan tapes, track every file through validation and mapping,
          and work with the resulting reports - in one place.
        </p>
        <ul className="auth-hero-points">
          <li><i className="pi pi-cloud-upload" /> Secure file ingestion</li>
          <li><i className="pi pi-check-circle" /> Automated data checks</li>
          <li><i className="pi pi-chart-line" /> Monitoring &amp; reporting</li>
        </ul>
      </div>
      <div className="auth-hero-footer">Exaloan AG &copy; {new Date().getFullYear()}</div>
    </section>
    <section className="auth-panel">
      {children}
    </section>
  </div>
);

export default AuthLayout;
